// Modules
import React from 'react';

// Styles
import styles from './OrderComplete.module.scss';

// Components
import SuccessHeader from './SuccessHeader';
import CustomHR from './CustomHR';
import PrivacyDataDisplay from './PrivacyDataDisplay';

const OrderComplete = (props) => {
  const { receiptType = '', sentTo = '' } = props;

  return (
    <>
      <SuccessHeader>
        {receiptType === 'email' && sentTo ? (
          <p>
            Your receipt has been emailed to{' '}
            <PrivacyDataDisplay email={sentTo} />
          </p>
        ) : null}

        {receiptType === 'text_message' && sentTo ? (
          <p>
            Your receipt has been texted to{' '}
            <PrivacyDataDisplay phone={sentTo} />
          </p>
        ) : null}
      </SuccessHeader>

      <CustomHR />

      <p className={styles.completeMsg}>
        Your payment has been completed successfully
      </p>
    </>
  );
};

export default OrderComplete;
